import React, { useState, useEffect } from 'react';
import { getUseCases, deleteUseCase } from '../services/api';
import UseCaseContainer from '../components/UseCaseContainer';
import UseCaseList from '../components/UseCaseList';

const UseCasesDashboard = () => {
  const [useCases, setUseCases] = useState([]);
  const [selectedUseCaseId, setSelectedUseCaseId] = useState(null);

  useEffect(() => {
    const refreshUseCaseList = async () => {
      try {
        const response = await getUseCases();
        if (response && Array.isArray(response)) {
          setUseCases(response);
          // Auto-select first use case if none selected
          if (!selectedUseCaseId && response.length > 0) {
            setSelectedUseCaseId(response[0].id);
          }
        }
      } catch (error) {
        console.error('Error loading use cases:', error);
      }
    };

    refreshUseCaseList();
  }, [selectedUseCaseId]);

  const refreshUseCaseList = async () => {
    try {
      const response = await getUseCases();
      if (response && Array.isArray(response)) {
        setUseCases(response);
      }
    } catch (error) {
      console.error('Error refreshing use cases:', error);
    }
  };

  const handleSelectNewlyCreated = (newId) => {
    setSelectedUseCaseId(newId);
    refreshUseCaseList();
  };

  const handleDelete = async (useCaseId) => {
    try {
      await deleteUseCase(useCaseId);
      await refreshUseCaseList();
      // If the deleted use case was selected, clear selection
      if (selectedUseCaseId === useCaseId) {
        setSelectedUseCaseId(null);
      }
    } catch (error) {
      alert('Fehler beim Löschen: ' + error.message);
    }
  };

  return (
    <div style={{ 
      height: 'calc(100vh - 120px)', 
      display: 'flex', 
      gap: '20px',
      padding: '20px'
    }}>
      {/* Left sidebar - Use Case List */}
      <div style={{ 
        width: '300px',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px'
      }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <h2 style={{ margin: 0 }}>Use Cases</h2>
          <button 
            onClick={() => setSelectedUseCaseId('new')}
            className="accent"
            style={{
              padding: '8px 16px',
              fontSize: '14px',
              width: '100%'
            }}
          >
            + Neuen Use Case erstellen
          </button>
        </div>
        
        <UseCaseList
          useCases={useCases}
          selectedId={selectedUseCaseId}
          onSelect={setSelectedUseCaseId}
          onDelete={handleDelete}
        />
      </div>

      {/* Right side - Use Case Details */}
      <div style={{ 
        flex: '1',
        border: '1px solid #dee2e6',
        borderRadius: '4px',
        overflow: 'hidden'
      }}>
        {selectedUseCaseId ? (
          <UseCaseContainer
            useCaseId={selectedUseCaseId}
            refreshUseCaseList={refreshUseCaseList}
            onSelectNewlyCreated={handleSelectNewlyCreated}
          />
        ) : (
          <div style={{ 
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#6c757d',
            fontSize: '18px'
          }}>
            Select a use case to start editing or create a new one
          </div>
        )}
      </div>
    </div>
  );
};

export default UseCasesDashboard;
